module.exports = __webpack_public_path__ + "static/media/settings_twofactorauthorisation.0ff7d03e.svg";